import { render } from "./wage-money-position-salary.vue?vue&type=template&id=165eb44f"
import script from "./wage-money-position-salary.vue?vue&type=script&lang=js"
export * from "./wage-money-position-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-money-position-salary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "165eb44f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('165eb44f', __exports__)) {
    api.reload('165eb44f', __exports__)
  }
  
  module.hot.accept("./wage-money-position-salary.vue?vue&type=template&id=165eb44f", () => {
    api.rerender('165eb44f', render)
  })

}


export default __exports__